import { getLang } from "./translator";

const getCurrentLocaleCode = () => {
  const lang = getLang();

  switch (lang) {
    case "pl":
      return "pl";
    case "en":
    default:
      return "en-US";
  }
};

// eslint-disable-next-line import/no-dynamic-require, global-require
const getLocale = (locale) => require(`date-fns/locale/${locale}/index.js`);

export const getCurrentLocale = () => {
  const locale = getLocale(getCurrentLocaleCode());

  return {
    ...locale,
    // formatLong: {
    //   ...locale.formatLong,
    //   // time: buildFormatLongFn({
    //   //   formats: {
    //   //     // am/pm
    //   //     full: "h:mm:ss a zzzz",
    //   //     long: "h:mm:ss a z",
    //   //     medium: "h:mm:ss a",
    //   //     short: "h:mm a",
    //   //     // 24
    //   //     // full: 'HH:mm:ss zzzz',
    //   //     // long: 'HH:mm:ss z',
    //   //     // medium: 'HH:mm:ss',
    //   //     // short: 'HH:mm',
    //   //   },
    //   //   defaultWidth: "full",
    //   // }),
    // },
    // options: {
    //   ...locale.options,
    //   // Sunday
    //   // weekStartsOn: 0,
    //   // firstWeekContainsDate: 1,
    //   // Monday
    //   weekStartsOn: 1,
    //   firstWeekContainsDate: 4,
    // },
  };
};

export const dateFnsOptions = (options) => ({
  locale: getCurrentLocale(),
  ...options,
});
